import MetaTags from "react-meta-tags";
import React, { useState, useRef, useEffect, useContext } from "react";
import { History } from "history";
import { useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import{ Spinner } from 'reactstrap';
import logo from "../../assets/images/logo.png";
import loginBG from "../../assets/images/login-bg.png";
import { IAuthUser } from "../../models/Authentication/Authentication.models";
import { AuthAPIService } from "src/api/Authentication/API_AuthService";
import { login } from "src/store/Authentication/authActions";
import { GetSeriesAdvises } from "src/services/General/SerieService";
import { sweetHTMLAlert } from "src/shared/services/AlertService";
import { isNullOrEmpty } from "src/helpers/generalFunctions";
import { SendEmailOTP, ShowUserOnboard } from "src/services/Maintenance/UserService";
import { RefsContext } from "src/contexts/OnboardingContext";
import { GetConfigurationByCode } from "src/services/General/ConfigurationService";
import { USER_TIMEOUT } from "src/constants/localStorage";
import { VERSION } from "src/constants/version";

interface LoginProps {
  history: History;
}
const username = "username";
const password = "password";
const OTP = "OTP";

const LoginNew = ({ history }: LoginProps) => {
  const dispatch = useDispatch();
  const refsContext = useContext(RefsContext);
  const formRef = useRef<any>(null);

  if (!refsContext) {
    return null; // O maneja el caso donde el contexto no está disponible
  }
  const { setShowOnboard } = refsContext;
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingEmail, setLoadingEmail] = useState<boolean>(false);
  const [seePass, setSeePass] = useState<boolean>(false);
  const [seeOTP, setSeeOTP] = useState<boolean>(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [isInvalidOTP, setIsInvalidOTP] = useState(false);
  const [OTPImg, setOTPImg] = useState('');
  const [OTPReq, setOTPReq] = useState(false);
  const [OTPGoogleReq, setOTPGoogleReq] = useState(false);
  const [OTPEmailReq, setOTPEmailReq] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const isMountedRef = useRef(true);
  const usernameRef = useRef<HTMLInputElement>(null);

  const handleInvalid = () => {
    setIsInvalid(true);
  };

  const handleValid = () => {
    setIsInvalid(false);
  };

  const handleInvalidOTP = () => {
    setIsInvalidOTP(true);
  };

  const handleValidOTP = () => {
    setIsInvalidOTP(false);
  };

  useEffect(() => {
    return () => {
      setLoading(null as any);
      isMountedRef.current = false;
    };
  }, []);

  const authenticateOTP = (model: IAuthUser) => {
    setLoading(true);
    AuthAPIService.authenticate(model)
      .then(async response => {
        if(response.employeeId)
        if (isMountedRef.current) dispatch(login(response));
        
        // llamar para validar series que esten en su numero de alerta o a punto de expirar
        const rad = await GetSeriesAdvises();
        if (rad?.success && rad?.data?.message.length > 0) {
          var r = await sweetHTMLAlert(
            rad.data.title,
            rad.data.message,
            "Aceptar",
            "info"
          );
          if(r)
          {
            var show = await ShowUserOnboard()
            if(show?.success && !show.data.onboard)
              setShowOnboard(true);
          }
        }else{
          var show = await ShowUserOnboard()
          if(show?.success && !show.data.onboard)
            setShowOnboard(true);
        }
      })
      .catch(error => {
        if (isMountedRef.current) console.log(error);
      })
      .finally(() => {
        if (isMountedRef.current) setLoading(false);
      });
  };

  const authenticate = (model: IAuthUser) => {
    setLoading(true);
    AuthAPIService.authenticate(model)
      .then(async response => {
        if(response.requiredOTP)
        {
          if(response.googleOTP == false && response.emailOTP == true)
            setEmailSent(true)
          setOTPReq(true);
          setOTPGoogleReq(response.googleOTP);
          setOTPEmailReq(response.emailOTP);

          // setOTPImg(response.htmlOTP);
          return;
        }
        dispatch(login(response));
        
        // Obtener configuración USER_TIMEOUT y guardarla en localStorage
        try {
          const timeoutResponse = await GetConfigurationByCode(dispatch, "USER_TIMEOUT");
          if (timeoutResponse?.success && timeoutResponse.data?.value) {
            const timeoutSeconds = parseInt(timeoutResponse.data.value, 10);
            if (!isNaN(timeoutSeconds) && timeoutSeconds > 0) {
              localStorage.setItem(USER_TIMEOUT, timeoutSeconds.toString());
            } else {
              // Si el valor es 0 o inválido, eliminar de localStorage para desactivar logout automático
              localStorage.removeItem(USER_TIMEOUT);
            }
          } else {
            // Si no se encuentra la configuración, eliminar de localStorage
            localStorage.removeItem(USER_TIMEOUT);
          }
        } catch (error) {
          console.error("Error al obtener configuración USER_TIMEOUT:", error);
          // Si hay error, eliminar de localStorage para desactivar logout automático
          localStorage.removeItem(USER_TIMEOUT);
        }
        
        // llamar para validar series que esten en su numero de alerta o a punto de expirar
        const rad = await GetSeriesAdvises();
        if (rad?.success && rad?.data?.message.length > 0) {
          var r = await sweetHTMLAlert(
            rad.data.title,
            rad.data.message,
            "Aceptar",
            "info"
          );
          if(r)
          {
            var show = await ShowUserOnboard()
            if(show?.success && !show.data.onboard)
              setShowOnboard(true);
          }
        }else{
          var show = await ShowUserOnboard()
          if(show?.success && !show.data.onboard)
            setShowOnboard(true);
        }
      })
      .catch(error => {
        if (isMountedRef.current) console.log(error);
      })
      .finally(() => {
        if (isMountedRef.current) setLoading(false);
      });
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login</title>
      </MetaTags>
      <div className="app app-without-header">
        <div className="p-0">
          <div className="login login-v1" style={{ display: 'flex', }}>
            <div className="login-container" style={{ flex: 2, alignItems: 'center', justifyContent: 'center'  }}>

                <div className="login-header" style={{paddingBottom: "0 !important"}}>
                  <div className="brand">
                    <img src={logo} alt="logo" width="200" />
                    <h4 className="mt-3">Bienvenido a Dual Cloud ERP</h4>
                  </div>
                </div>
                <div className="jp">
                    <p>Accede a tu cuenta para una gestión eficiente y segura de tu empresa.</p>
                </div>

                <div className="login-body">
                  <div className="login-content fs-13px">
                    {/* {
                      OTPReq && !isNullOrEmpty( OTPImg ) && 
                        <div dangerouslySetInnerHTML={{ __html: OTPImg }} />
                    } */}
                    <AvForm
                        id="loginForm"
                        ref={formRef}
                        className="custom-form pt-2"
                        onInvalidSubmit={(e: any, model: any) => {
                          if (Array.isArray(model) && model.includes("password")) {
                            handleInvalid();
                          }
                          if (Array.isArray(model) && model.includes("OTP") && OTPReq) {
                            handleInvalidOTP();
                          }
                        }}                        
                        onValidSubmit={(e: any, model: IAuthUser) => {
                          if(OTPReq)
                            {
                              model.isOTP = true;
                              model.isEmail = emailSent;
                              authenticateOTP(model);
                            }
                          else 
                            authenticate(model);
                        }}>
                        
                        <div className="mb-4" hidden={OTPReq}>
                          <AvField
                            name={username}
                            hidden={OTPReq}
                            label="Usuario"
                            innerRef={usernameRef}
                            value=""
                            className="form-control"
                            placeholder="Ingresa tu usuario"
                            type="text"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Este campo es requerido",
                              },
                            }}
                          />
                        </div>
                        <div className="mb-3">
                        {
                          OTPReq ? 
                              <div className="d-flex align-items-start">
                                <div className="flex-grow-1">
                                  <label className="form-label" style={{ color: isInvalidOTP ? "#F44336": "#000", fontWeight: "normal"}}>Código OTP</label>
                                </div>
                              </div>
                          : <div className="d-flex align-items-start">
                                <div className="flex-grow-1">
                                  <label className="form-label" style={{ color: isInvalid ? "#F44336": "#000", fontWeight: "normal"}}>Contraseña</label>
                                </div>
                              </div>
                        }

                          <div className="mb-3 position-relative" hidden={OTPReq}>
                            <AvField
                              name={password}
                              hidden={OTPReq}
                              value=""
                              type={seePass ? "text" : "password"}
                              className="pass form-control"
                              required
                              placeholder="Ingresa tu contraseña"
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Este campo es requerido",
                                },
                              }}
                              onChange={(e, value) => {
                                if (isNullOrEmpty(value)) {
                                  handleInvalid();
                                } else {
                                  handleValid();
                                }
                              }}
                              onBlur={(e) => {
                                if (isNullOrEmpty(e.target.value)) {
                                  handleInvalid();
                                } else {
                                  handleValid();
                                }
                              }}
                            />
                            {
                              OTPReq ? null :
                              isInvalid ?
                                <span
                                  className="position-absolute"
                                  style={{
                                    right: '10px',
                                    top: '30%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => setSeePass(!seePass)}
                                >
                                  {seePass ? <i style={{color:"#B8B8B8"}} className="fa-solid fa-eye-slash d-none d-xl-inline-block" /> : <i style={{color:"#B8B8B8"}} className="fa-solid fa-eye d-none d-xl-inline-block" />}
                                </span> : 
                                <span
                                  className="position-absolute"
                                  style={{
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => setSeePass(!seePass)}
                                >
                                  {seePass ? <i style={{color:"#B8B8B8"}} className="fa-solid fa-eye-slash d-none d-xl-inline-block" /> : <i style={{color:"#B8B8B8"}} className="fa-solid fa-eye d-none d-xl-inline-block" />}
                                </span>
                            }
                          </div>
                          <div className="mb-3 position-relative" hidden={!OTPReq}>
                            <AvField
                              name={OTP}
                              value=""
                              hidden={!OTPReq}
                              // type={seeOTP ? "text" : "password"}
                              type={"text" }
                              className="form-control"
                              required
                              placeholder="Ingresa tu OTP"
                              validate={{
                                required: {
                                  value: OTPReq,
                                  errorMessage: "Campo OTP es requerido",
                                },
                              }}
                              onChange={(e, value) => {
                                if (isNullOrEmpty(value) && OTPReq) {
                                  handleInvalidOTP();
                                } else {
                                  handleValidOTP();
                                }
                              }}
                              onBlur={(e) => {
                                if (isNullOrEmpty(e.target.value) && OTPReq) {
                                  handleInvalidOTP();
                                } else {
                                  handleValidOTP();
                                }
                              }}
                            />
                            {/* {
                              !OTPReq ? null :
                              isInvalidOTP ?
                                <span
                                  className="position-absolute"
                                  style={{
                                    right: '10px',
                                    top: '30%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => setSeeOTP(!seeOTP)}
                                >
                                  {seeOTP ? <i style={{color:"#B8B8B8"}} className="fa-solid fa-eye-slash d-none d-xl-inline-block" /> : <i style={{color:"#B8B8B8"}} className="fa-solid fa-eye d-none d-xl-inline-block" />}
                                </span> : 
                                <span
                                  className="position-absolute"
                                  style={{
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => setSeeOTP(!seeOTP)}
                                >
                                  {seeOTP ? <i style={{color:"#B8B8B8"}} className="fa-solid fa-eye-slash d-none d-xl-inline-block" /> : <i style={{color:"#B8B8B8"}} className="fa-solid fa-eye d-none d-xl-inline-block" />}
                                </span>
                            } */}
                          </div>
                        </div>
                        <div className="mt-5 mb-3">
                          {!loading ? (
                            OTPReq ? 
                            <>
                            <button
                              className="btn h-45px btn-primary w-100 waves-effect waves-light"
                              type="submit"
                              disabled={loading}
                            >
                              Iniciar sesión
                            </button>
                            <div className="mt-3 " hidden={!OTPEmailReq}>
                              <p className="mb-1 text-center" hidden={!OTPEmailReq || emailSent}>
                                <span  
                                  onClick={async () => {
                                    if(!loadingEmail)
                                    {
                                      setLoadingEmail(true);
                                      const usernameValue = usernameRef.current?.value;
                                      if (usernameValue) {
                                        var resp = await SendEmailOTP(usernameValue);
                                        if (resp?.success) setEmailSent(true);
                                      }
                                      setLoadingEmail(false);
                                    }
                                }}
                                style={{color:"#2196F3", cursor:"pointer"}}
                              >
                                {
                                  loadingEmail && <Spinner size={'sm'} /> 
                                }
                                {" "} Enviar código a correo{" "} 
                              </span>
                              </p>
                              <p className="mb-1 text-center" hidden={!OTPEmailReq || !emailSent}>
                                <span  
                              >
                                Ingresa el código enviado a tu correo{" "} 
                              </span>
                              </p>
                            </div>
                            <div className="mt-5 ">
                              <p className="mb-1 text-center">
                                <span  onClick={() => {
                                  setOTPReq(false);
                                  setOTPGoogleReq(false);
                                  setOTPEmailReq(false);
                                  setOTPImg('');
                                  setEmailSent(false);
                                  formRef.current && formRef.current.reset();
                                }}
                                style={{color:"#2196F3", cursor:"pointer"}}
                              >
                                Regresar{" "}
                              </span>
                              </p>
                            </div>
                            </>
                            :
                            <>
                              <button
                                className="btn h-45px btn-primary w-100 waves-effect waves-light"
                                type="submit"
                                disabled={loading}
                              >
                                Iniciar sesión
                              </button>
                              <div className="mt-5 ">
                                <p className="mb-1 text-center">
                                  ¿Has olvidado tu contraseña?{" "}
                                </p>
                                <p className="mb-0 text-center">
                                  <Link
                                    to="/forget-password"
                                    className="text-primary fw-bold"
                                    style={{fontWeight: 600}}
                                  >
                                    {" "}
                                    Reiniciar contraseña{" "}
                                  </Link>{" "}
                                </p>
                              </div>
                              <div className="mt-4 mt-md-5 text-center">
                                  <p className="mb-0">
                                    © {new Date().getFullYear()} DualTech - v. {VERSION}
                                  </p>
                                </div>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn h-45px btn-primary d-block w-100 btn-lg"
                              disabled={loading}
                            >
                              <Spinner size={'sm'} /> Cargando
                            </button>
                          )}
                        </div>
                    </AvForm>
                  </div>
                </div>
            </div>
            <div className="p-0" style={{flex: 2, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
              <img src={loginBG} alt="LogoImage" style={{
                // backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                maxWidth: '1000px',
                minWidth: '700px',
                width: "100%", /* 100% del ancho del contenedor */
                height: "100%",
                minHeight: '100vh',
                maxHeight: '100vh',
                objectFit: "cover",
                marginLeft: 'auto'
              }}/>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(LoginNew);
